/**
 * Fixes a stuck grey overlay after closing the mobile menu drawer.
 *
 * The overlay is pure CSS: `.header__icon--menu[aria-expanded=true]::before`
 * (snippets/base-css.liquid). Dawn's own header-drawer JS (assets/secondary.js,
 * class HeaderDrawer/MenuDrawer) sets aria-expanded="true" on the hamburger
 * <summary> when opening, and correctly resets it to "false" when the drawer
 * is closed via its dedicated X button (HeaderDrawer.closeButtonClick) - but
 * the far more common close path, tapping the hamburger a second time, goes
 * through MenuDrawer.closeMenuDrawer(), which never resets aria-expanded at
 * all. The drawer panel still slides away correctly either way; only the
 * overlay's CSS trigger is left stuck "true", so it never fades out.
 *
 * This listens for the native `toggle` event on the drawer's <details> -
 * which fires reliably whenever its `open` attribute changes, regardless of
 * which internal code path caused it (X button, re-tapping the hamburger,
 * Escape key, focusout) - and keeps aria-expanded in sync with the real
 * open state.
 */
(() => {
  'use strict';

  const DETAILS_SELECTOR = '#Details-menu-drawer-container';
  const TOGGLE_SELECTOR = 'summary.header__icon--menu';

  function sync(details) {
    const icon = details.querySelector(TOGGLE_SELECTOR);
    if (!icon) return;
    icon.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
  }

  function bind(details) {
    if (details.dataset.scsAriaFixBound) return;
    details.dataset.scsAriaFixBound = 'true';
    details.addEventListener('toggle', () => sync(details));
    sync(details);
  }

  function init() {
    document.querySelectorAll(DETAILS_SELECTOR).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();
